import { render } from "./Media.vue?vue&type=template&id=2632d92f"
import script from "./Media.vue?vue&type=script&lang=js"
export * from "./Media.vue?vue&type=script&lang=js"

import "./Media.vue?vue&type=style&index=0&id=2632d92f&lang=css"

import exportComponent from "D:\\helmi\\blitarenergi\\vue\\companyprofile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__